import SafeImage from '@ui/SafeImage';

interface MessageImageProps {
  img: string;
  fallbackImg?: string;
  onClick: (src: string) => void;
  onRightClick?: (ev: React.MouseEvent) => void;
}

export default function MessageImage({
  img,
  fallbackImg,
  onClick,
  onRightClick,
}: MessageImageProps) {
  return (
    <div className="relative h-[20rem] w-[20rem]" onContextMenu={onRightClick}>
      <SafeImage
        src={img}
        key={img}
        fill
        alt={'img'}
        fallbackSrc={fallbackImg}
        className="cursor-pointer object-cover"
        onClick={() => onClick(img)}
      />
    </div>
  );
}
